/* src/app/task-order-pdf/task-order-pdf.component.scss */
.certificate {
  width: 820px;
  padding: 20px;
  background-color: white;
  font-family: Arial, sans-serif;
}
.header {
  text-align: center;
}
.header img {
  max-width: 100%;
}
.content {
  margin-left: 50px;
  text-align: center;
}
.name {
  text-align: left;
  font-size: 24px;
  font-weight: bold;
}
.course {
  text-align: left;
  font-size: 18px;
  margin-top: 10px;
}
.course-topics {
  margin-top: 20px;
}
.course-topics ul {
  list-style-type: disc;
  padding-left: 20px;
}
.course-dates {
  margin-top: 20px;
}
.registration {
  text-align: right;
  margin-top: 20px;
}
li,
p {
  text-align: left;
}
li {
  margin-left: 15px;
}
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
}
th,
td {
  text-align: left;
}
.a4-sign {
  width: 150px;
  height: 59px;
}
.left {
  width: 40%;
}
.right {
  width: 60%;
}
/*# sourceMappingURL=task-order-pdf.component.css.map */
